export const preloadedValues = {
  unidRecStatus: false,
  unidTipo: 0,
  unidUnidade: "",
  unidDescricao: "",
};
